import * as Yup from 'yup'

export const initialFormValues = (values) => {
    return {
        brand_multiplier: values.brand_multiplier || "",
        brand_multiplier_type: values.brand_multiplier_type || "",
        category_multiplier: values.category_multiplier || "",
        category_multiplier_type: values.category_multiplier_type || "",
        product_multiplier: values.product_multiplier || "",
        product_multiplier_type: values.product_multiplier_type || "",
        credit_card_fee: values.credit_card_fee || "",
        credit_card_fee_type: values.credit_card_fee_type || "",
        multiplier_name: values.multiplier_name || "",
        multiplier: values.multiplier || "",
        multiplier_type: values.multiplier_type || ""
    }
}

export const formValidationSchema = Yup.object({
    brand_multiplier: Yup.string().required('This field is required'),
    category_multiplier: Yup.string().required('This field is required'),
    product_multiplier: Yup.string().required('This field is required'),
    credit_card_fee: Yup.string().required('This field is required'),
})
